import React, { ReactElement } from 'react';
import { ResponsiveType } from 'react-multi-carousel';
import { Carousel, ICarouselOptions } from '@kursk/components/ui/Carousel/Carousel';
import styles from './RecommendatiosBlock.module.scss';
// eslint-disable-next-line max-len
import { RecommendationsSingle } from "@kursk/components/ui/RecommendationsBlock/RecommendationsSingle/RecommendationsSingle";
import { CustomButtonGroup } from "@kursk/components/ui/Carousel/Buttons/ButtonGroup";
import { EventCard } from '@kursk/components/pages/Home/Events/EventCard/EventCard';
import { MovieCard } from "@kursk/components/pages/Movies/MovieCard/MovieCard";
import { EntityType } from "@common/redux/types/common";
import { SectionLink } from "@kursk/components/ui/SectionLink/SectionLink";

interface IProps {
  data: any[];
  title: string;
  goTo: string;
  goToTitle?: string;
  entityType: EntityType;
  pushkinPage?: boolean;
  theme?: 'white';
  newTab?: boolean;
}

export function RecommendationsBlock({
  data,
  title,
  goTo,
  goToTitle,
  entityType,
  pushkinPage = false,
  theme = null,
  newTab = false,
}: IProps): ReactElement {
  const renderCard = (item: any) => {
    switch (entityType) {
      case "events": {
        return <EventCard key={item._id} event={item} type="small" theme={theme}/>
      }
      case "movies": {
        return <MovieCard key={item._id} movie={item} type="small"/>
      }
      default: {
        return <RecommendationsSingle key={item._id} entity={item} entityType={entityType} link={goTo} newTab={newTab}/>
      }
    }
  };

  const responsive: ResponsiveType = {
    desktop1: {
      breakpoint: { max: 9999, min: 1200 },
      items: 4,
    },
    tablet2: {
      breakpoint: { max: 1150, min: 1020 },
      items: 3,
      partialVisibilityGutter: 50
    },
    tablet3: {
      breakpoint: { max: 1020, min: 900 },
      items: 3,
    },
    tablet4: {
      breakpoint: { max: 900, min: 700 },
      items: 2,
      partialVisibilityGutter: 50
    },
    mobile: {
      breakpoint: { max: 699, min: 0 },
      items: 1,
      partialVisibilityGutter: 80
    }
  };

  const options: ICarouselOptions = {
    responsive,
    swipeable: true,
    infinite: true,
    renderButtonGroupOutside: true,
    partialVisible: true,
    sliderClass: styles.carouselTrack
  };

  const cards = data.map(renderCard);

  if (!cards || cards.length === 0) {
    return <></>;
  }
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h2 className={styles.title}>{title}</h2>
        <SectionLink title={goToTitle} pushkinPage={pushkinPage} goTo={goTo}/>
      </div>
      <div className={styles.cardsCarousel}>
        <Carousel
          Buttons={cards.length > 4 && <CustomButtonGroup className={styles.carouselButtons}/>}
          carouselOptions={options}
        >
          {cards}
        </Carousel>
      </div>
    </div>
  )
}
